export const avatarAiPreviewGenderOptions = [
  { id: "male", label: "Uomo" },
  { id: "female", label: "Donna" },
];

const femaleThemeLabels = {
  "funeral-director": "Direttrice Funeraria",
  "ceremony-officiant": "Cerimoniera",
  "eulogy-speaker": "Oratrice Commemorativa",
  "gothic-burton": "Gotica Burton",
  superhero: "Supereroina",
};

const femaleThemeDescriptions = {
  "funeral-director": "Direttrice di onoranze funebri, look classico.",
  "ceremony-officiant": "Cerimoniera o officiante in tono solenne.",
  "eulogy-speaker": "Oratrice commemorativa, postura solenne.",
  "creative-pro": "Vibe creativa ma curata.",
  superhero: "Eroina da copertina comics.",
};

export const getAvatarAiThemeLabel = (theme = {}, gender = "male") =>
  theme.labels?.[gender] ||
  (gender === "female" ? femaleThemeLabels[theme.id] : "") ||
  theme.label ||
  "";

export const getAvatarAiThemeDescription = (theme = {}, gender = "male") =>
  theme.descriptions?.[gender] ||
  (gender === "female" ? femaleThemeDescriptions[theme.id] : "") ||
  theme.description ||
  "";

export const getAvatarAiThemeThumbnailUrl = (theme = {}, gender = "male") => {
  const explicitUrl = theme.thumbnailUrls?.[gender];
  if (explicitUrl) return explicitUrl;

  const fallbackUrl = theme.thumbnailUrl || "";
  if (gender !== "female" || !theme.id || !fallbackUrl) return fallbackUrl;

  const malePath = `/themes/${theme.id}.jpeg`;
  if (!fallbackUrl.includes(malePath)) return fallbackUrl;

  return fallbackUrl.replace(malePath, `/themes/female/${theme.id}.jpeg`);
};
